var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLightBulb = function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.198 3.342a7.723 7.723 0 00.54 11.296c1.424 1.207 1.078 2.805 1.13 3.12v2.664h1.288A2.581 2.581 0 0011.735 23a2.581 2.581 0 002.578-2.578h1.289v-2.664c.053-.32-.3-1.904 1.14-3.13a7.726 7.726 0 002.727-5.894c0-6.934-8.455-10.339-13.27-5.392zm5.537 18.369a1.29 1.29 0 01-1.29-1.29h2.579c0 .712-.579 1.29-1.29 1.29zm2.578-2.578H9.156v-1.375h5.157v1.375zm1.595-5.487a4.5 4.5 0 00-1.555 2.822h-1.974v-4.593a2.583 2.583 0 001.934-2.497h-1.29c0 .711-.578 1.29-1.288 1.29a1.29 1.29 0 01-1.29-1.29H9.157c0 1.2.823 2.21 1.934 2.497v4.593H9.117a4.466 4.466 0 00-1.546-2.814c-4.54-3.846-1.837-11.202 3.98-11.363 6.077-.17 8.971 7.431 4.357 11.355z"
  })));
};

export default SvgLightBulb;